import { defineComponent as q, ref as o, useSlots as S, reactive as _, computed as v, provide as W, openBlock as h, createElementBlock as N, normalizeStyle as D, createVNode as s, mergeProps as I, withCtx as i, createTextVNode as L, toDisplayString as M, renderSlot as B, createBlock as $, normalizeClass as x, createCommentVNode as V } from "vue";
import { getMainButtonStyleClasses as A } from "./novoui-vuejs817.js";
import b from "./novoui-vuejs2.js";
import E from "./novoui-vuejs9.js";
import P from "./novoui-vuejs22.js";
import { SplitButtonListSymbol as T } from "./novoui-vuejs57.js";
const O = /* @__PURE__ */ q({
  __name: "NButtonSplit",
  props: {
    variant: { default: "fill" },
    size: { default: "medium" },
    disabled: { type: Boolean, default: !1 },
    square: { type: Boolean, default: !1 },
    forceWidth: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    onClick: {}
  },
  setup(C) {
    const t = C, n = o(), d = o(), a = o(), r = o(), u = o(!0), c = S();
    function k(e, f, l = {}) {
      c.default && c.default().forEach((z) => {
        var m;
        ((m = z.props) == null ? void 0 : m.onClick) === e && (r.value = e);
      }), n.value = f, d.value = e, a.value = l;
    }
    function w(e) {
      u.value = !e;
    }
    const y = _({
      replace: k,
      emitInstead: !0,
      size: v(() => t.size),
      activeMethod: r,
      isClickedButtonDisabled: w
    });
    W(T, y);
    const g = v(() => A(t));
    return (e, f) => (h(), N("div", {
      class: "button-split",
      style: D({ width: t.fullWidth ? "100%" : t.forceWidth ? t.forceWidth : "auto" })
    }, [
      s(b, I(a.value, {
        class: g.value,
        "force-width": t.forceWidth,
        "full-width": t.fullWidth,
        disabled: t.disabled,
        variant: t.variant,
        size: t.size,
        square: t.square,
        "trailing-icon": void 0,
        "data-testid": `${a.value && a.value["data-testid"]}-main-button-split`,
        onClick: d.value,
        "is-loading": t.isLoading
      }), {
        default: i(() => [
          L(M(n.value), 1)
        ]),
        _: 1
      }, 16, ["class", "force-width", "full-width", "disabled", "variant", "size", "square", "data-testid", "onClick", "is-loading"]),
      B(e.$slots, "dropdown", {}, () => [
        t.isLoading ? V("", !0) : (h(), $(E, {
          key: 0,
          indicator: "right",
          "hide-indicator": !0,
          width: "auto",
          "close-on-content-click": u.value
        }, {
          activator: i(({ onActivate: l, setActivatorRef: p }) => [
            s(b, {
              disabled: t.disabled,
              class: x(["button-split-dropdown", [{ "button-icon-square": t.square }]]),
              type: "primary",
              variant: t.variant,
              size: t.size,
              square: t.square,
              icon: "stepDown",
              "set-ref": p,
              "data-testid": "test-button-split-dropdown",
              onClick: l
            }, null, 8, ["disabled", "class", "variant", "size", "square", "set-ref", "onClick"])
          ]),
          content: i(() => [
            s(P, { padding: "large" }, {
              default: i(() => [
                B(e.$slots, "default")
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["close-on-content-click"]))
      ])
    ], 4));
  }
});
export {
  O as default
};
